(function ($) {

  $(document).ready(function () {
    var topBlock = $(".c-services__block--top");
    var rightBlock = $(".c-services__block--right");
    var bottomBlock = $(".c-services__block--bottom");
    var leftBlock = $(".c-services__block--left");

    var slideNow = 3;
    var slideCount = $('.JS-c-services__blocks').children().length;
    var textCount = $('.JS-c-services__text').children().length;

    $('.JS-c-services__arrow--left').click(function () {
      nextSlide();
    });

    $('.JS-c-services__arrow--right').click(function () {
      prevSlide();
    });

    function prevSlide() {
      $(".JS-c-services--animation").attr('class', 'c-services--animation JS-c-services--animation');
      $('.c-services__block').removeClass("for-close for-open");
      $('.c-services__text--block').removeClass("text-for-close text-for-open");
      if (slideNow == slideCount || slideNow <= 0 || slideNow > slideCount) {
        slideNow = 1;
        $('.c-services__block--active').addClass("for-close").removeClass("c-services__block--active");
        $('.c-services__block').eq(slideNow - 1).addClass("c-services__block--active for-open");
        $('.c-services__text--block--active').addClass("text-for-close").removeClass("c-services__text--block--active");
        $('.c-services__text--block').eq(slideNow - 1).addClass("c-services__text--block--active text-for-open");
      } else {
        slideNow++;
        $('.c-services__block--active').addClass("for-close").removeClass("c-services__block--active");
        $('.c-services__block').eq(slideNow - 1).addClass("c-services__block--active for-open");
        $('.c-services__text--block--active').addClass("text-for-close").removeClass("c-services__text--block--active");
        $('.c-services__text--block').eq(slideNow - 1).addClass("c-services__text--block--active text-for-open");
      }
      if (leftBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("bottom-center");
      } else if (topBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("left-center");
      } else if (rightBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("top-center");
      } else {
        $(".JS-c-services--animation").addClass("right-center");
      }
    }

    function nextSlide() {
      $(".JS-c-services--animation").attr('class', 'c-services--animation JS-c-services--animation');
      $('.c-services__block').removeClass("for-close for-open");
      $('.c-services__text--block').removeClass("text-for-close text-for-open");
      if (slideNow == 1 || slideNow <= 0 || slideNow > slideCount) {
        slideNow = slideCount;
        $('.c-services__block--active').addClass("for-close").removeClass("c-services__block--active");
        $('.c-services__block').eq(slideNow - 1).addClass("c-services__block--active for-open");
        $('.c-services__text--block--active').addClass("text-for-close").removeClass("c-services__text--block--active");
        $('.c-services__text--block').eq(slideNow - 1).addClass("c-services__text--block--active text-for-open");

      } else {
        slideNow--;
        $('.c-services__block--active').addClass("for-close").removeClass("c-services__block--active");
        $('.c-services__block').eq(slideNow - 1).addClass("c-services__block--active for-open");
        $('.c-services__text--block--active').addClass("text-for-close").removeClass("c-services__text--block--active");
        $('.c-services__text--block').eq(slideNow - 1).addClass("c-services__text--block--active text-for-open");
      }
      if (leftBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("center-top");
      } else if (topBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("center-right");
      } else if (rightBlock.hasClass("c-services__block--active")) {
        $(".JS-c-services--animation").addClass("center-bottom");
      } else {
        $(".JS-c-services--animation").addClass("center-left");
      }
    }

    $('.JS-c-services__block').each(function () {
      $(this).click(function () {
        var index = $(this).index();
        $('.c-services__block--active').addClass("text-for-close").removeClass("c-services__block--active for-open");
        $('.c-services__text--block--active').removeClass("c-services__text--block--active");
        $('.c-services__text--block').removeClass("text-for-close text-for-open");
        $(".JS-c-services--animation").attr('class', 'c-services--animation JS-c-services--animation');

        if (slideNow == 1 && index == 1) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(2)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("top-center");
          slideNow = 2;
        } else if (slideNow == 1 && index == 2) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(3)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("top-bottom-big");
          slideNow = 3;
        } else if (slideNow == 1 && index == 3) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(4)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("center-top");
          slideNow = 4;
        }

        else if (slideNow == 2 && index == 0) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(1)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("center-right");
          slideNow = 1;

        } else if (slideNow == 2 && index == 2) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(3)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("right-center");
          slideNow = 3;

        } else if (slideNow == 2 && index == 3) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(4)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("right-left-big");
          slideNow = 4;

        }

        else if (slideNow == 3 && index == 0) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(1)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("bottom-top-big");
          slideNow = 1;
        } else if (slideNow == 3 && index == 1) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(2)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("center-bottom");
          slideNow = 2;
        } else if (slideNow == 3 && index == 3) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(4)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("bottom-center");
          slideNow = 4;
        }

        else if (slideNow == 4 && index == 0) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(1)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("left-center");
          slideNow = 1;
        } else if (slideNow == 4 && index == 1) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(2)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("left-right-big");
          slideNow = 2;
        } else if (slideNow == 4 && index == 2) {
          $(this).addClass("c-services__block--active for-open");
          $('.c-services__text--block:nth-child(3)').addClass("c-services__text--block--active text-for-open");
          $(".JS-c-services--animation").addClass("center-left");
          slideNow = 3;
        }
      });
    });
  });

})(jQuery);